import React, { useState } from "react";
import moment from "moment";
import {
  getField,
  deserializeField,
  padZerosToString,
  formatDate,
} from "../../../../util/DynamicItemUtils";

export default function AuditClientAndReport({ item }: any) {
  const dateParsingFormat = "YYYY-MM-DDTHH:mm:ss";
  const dateDisplayFormat = "MM/DD/YYYY";

  const [showAllFundSeriesInfo, setShowAllFundSeriesInfo] = useState(false);

  const issuerCik = getField(item, "issuercik");
  const auditFundSeries = deserializeField(item, "auditfundseries");
  const secEngagementPartnerID = getField(item, "secengagementpartnerid");

  // getField pulls first element of array, declare directly to preserve array n concat
  const engagementPartnerOtherIDs = getField(item, "engagementpartnerotherids");
  const engagementPartnerOtherIDsConcat =
    engagementPartnerOtherIDs &&
    item.Document["engagementpartnerotherids"].join(", ");

  // Locations are split into individual strings, declaring in array filtering/concatenating
  const firmLocation = [
    getField(item, "engagementpartnercity"),
    getField(item, "engagementpartnerstate"),
    getField(item, "engagementpartnercountry"),
  ]
    .filter((name) => !!name && name !== "United States")
    .join(", ");

  // Format dates but keep in array
  const auditDualDate = getField(item, "auditdualdate");
  const auditDualDates =
    auditDualDate &&
    item.Document["auditdualdate"]
      .map((date) => {
        return moment(date, dateParsingFormat).format(formatDate(date));
      })
      .join(", ");

  // Names are split into individual strings, declaring in array n concatenating
  const secEngagementPartnerName = [
    getField(item, "secengagementpartnerfirstname"),
    getField(item, "secengagementpartnermiddlename"),
    getField(item, "secengagementpartnerlastname"),
  ]
    .filter((name) => !!name)
    .join(" ");

  // getField pulls first element of array, declare directly to preserve array n concat
  const secOtherEngagementPartnerIDs = getField(
    item,
    "secengagementpartnerotherids"
  );
  const secEngagementPartnerOtherIDsConcat =
    secOtherEngagementPartnerIDs &&
    item.Document["secengagementpartnerotherids"].join(", ");

  function generateFundSeriesTable(fundSeries) {
    return (
      <div>
        <h3>Fund Series</h3>
        <table className="fund-series__table">
          <thead>
            <tr>
              <td>Series Identifier</td>
              <td>Fund Name</td>
            </tr>
          </thead>
          <tbody>
            {fundSeries[0].map((series, i) => (
              <tr
                key={`fund-series-tr_${i}`}
                className={i > 2 && !showAllFundSeriesInfo ? "hide-row" : ""}
              >
                <td>{series.FundSeriesID}</td>
                <td>{series.FundName}</td>
              </tr>
            ))}
            {fundSeries[0].length > 3 && (
              <tr>
                <td>
                  <button
                    onClick={() =>
                      setShowAllFundSeriesInfo(!showAllFundSeriesInfo)
                    }
                  >
                    Show {showAllFundSeriesInfo ? "Less" : "More"}
                  </button>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className="form-card">
      <h2>Audit Client and Audit Report</h2>
      <h3>Issuer</h3>
      <p>{getField(item, "issuername")}</p>
      <p>CIK: {issuerCik ? `${padZerosToString(issuerCik)}` : "N/A"}</p>
      {auditFundSeries && generateFundSeriesTable(auditFundSeries)}
      <h3>Engagement Partner</h3>
      <p>{getField(item, "engagementpartnername")}</p>
      <p>Partner ID: {getField(item, "engagementpartnerid")}</p>
      {engagementPartnerOtherIDs && (
        <p>{`Other Partners ID(s): ${engagementPartnerOtherIDsConcat}`}</p>
      )}
      <h3>Audit Report</h3>
      <p>
        {`Audit Report Date: ${moment(
          getField(item, "auditreportdate"),
          dateParsingFormat
        ).format(formatDate(getField(item, "auditreportdate")))}`}
      </p>
      <p>
        {`Financial Statement Date: ${moment(
          getField(item, "fiscalperiodenddate"),
          dateParsingFormat
        ).format(formatDate(getField(item, "fiscalperiodenddate")))}`}
      </p>
      <p>{`Firm Location: ${firmLocation}`}</p>
      {getField(item, "dualdatedindicator") === "True" && (
        <div>
          <h3>Dual Dated</h3>
          <p>{`Audit Dual Date: ${auditDualDates}`}</p>
          {secEngagementPartnerName && (
            <p>
              {`Engagement partner for dual dated content: ${secEngagementPartnerName}`}
            </p>
          )}
          {secEngagementPartnerID && (
            <p>Partner ID: {secEngagementPartnerID}</p>
          )}
          {secOtherEngagementPartnerIDs && (
            <p>
              {`Other Partner ID(s): ${secEngagementPartnerOtherIDsConcat}`}
            </p>
          )}
        </div>
      )}
    </div>
  );
}
